import axios from 'axios'
import * as _ from 'lodash-es'
import jobPrefix from '../../common/service/jobPrefix.js'

/*
 * Job search.
 *
 * Was an Angular factory taking `$http` (step 35 of #614). It uses axios now; app.js installs the
 * same Cognito token on the shared axios instance that `$http`'s interceptor attached.
 */
const searchService = {
  findJobWithText: async (jobNumber, removeInvoiced) => {
    const t0 = performance.now()

    const res = await axios.get('/api/job/searchText', {
      params: { searchKey: jobNumber, removeInvoiced: removeInvoiced },
    })

    const t1 = performance.now()

    const results = []
    _.each(res.data.jobs, function (result) {
      results.push(result)
    })

    const t2 = performance.now()

    console.log(`search api call ${t1 - t0}ms`)
    console.log(`sort results ${t2 - t1}ms`)

    return results
  },

  label: item => {
    if (!item) {
      return
    }

    var label = item.jobNumber !== '' && item.jobNumber !== undefined ? jobPrefix.get() + item.jobNumber : ''

    if (item.title) {
      label += ' - ' + item.title
    }

    if (item.client) {
      label += ' - ' + item.client
    }

    if (item.brand) {
      label += ' - ' + item.brand
    }

    if (item.assets && item.assets.length > 0) {
      let assetList = []
      _.each(item.assets, asset => {
        if (!asset.deleted) {
          assetList.push(asset.clientKey || jobPrefix.get() + item.jobNumber + asset.sequence + asset.length)
        }
      })
      label += '<br/><small>' + assetList.join(', ') + '</small>'
    }

    return label
  },
}

export default searchService
